import IconUploadSolid from '@/assets/icons/font_awesome/upload-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { useToast } from '@/hooks/use-toast';
import i18n_grid2d from '@/locales/keys/i18n_grid2d.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { is_upload_image_to_grid_possible } from '@/utils/utils_grid2d';
import { upload_many_images_to_user_task_references } from '@/utils/utils_upload';
import { DTO__entity_with_grid2d } from '@shared/dto/+workspace/workspace_entity/_database_entity_with_grid2d_permissions/DTO__entity_with_grid2d';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';
import { useTranslation } from 'react-i18next';
import { UI_PRIMITIVE__tooltip } from '../../../../../components/ui/UI_PRIMITIVE__tooltip';

interface Props {
  grid2d: DTO__grid2d;
  entity: DTO__entity_with_grid2d;
}

export function GRID2D_BUTTON_images_upload({ grid2d, entity }: Props) {
  const dispatch = use_dispatch();
  const { toast } = useToast();
  const { t } = useTranslation(ENUM__i18n_namespace.GRID2D);

  /*
   * EVENTS
   */
  function onClick() {
    upload_many_images_to_user_task_references(toast, dispatch, grid2d, entity._id, t);
  }

  /*
   * HTML
   */

  if (!entity.is_add_external_image_possible()) return <></>;
  if (!is_upload_image_to_grid_possible(entity)) return <></>;

  return (
    <UI_PRIMITIVE__tooltip tooltip_title={t(i18n_grid2d.buttons.upload_image.tooltip)}>
      <UI_PRIMITIVE__button_with_icon_animated
        variant={'no-border-on-bar'}
        Icon={IconUploadSolid}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        {...{ onClick }}
        className="p-0 h-[28px] w-[30px] flex items-center justify-center"
        iconClassNameBase="!text-component-item-foreground !size-3"
        iconClassNameHovered="!text-bar-foreground"
      />
    </UI_PRIMITIVE__tooltip>
  );
}
